import { AppConfigService, APP_CONFIG } from '@config/app-config.service';

export { AppConfigService, APP_CONFIG };
